import { z } from 'zod'
import { timestampSchema, uuidSchema } from './common.ts'

export const CRM_TASK_TYPES = ['call', 'email', 'meeting', 'task'] as const
export const CRM_TASK_PRIORITIES = ['low', 'normal', 'high', 'urgent'] as const
export const CRM_TASK_STATUSES = ['open', 'completed', 'cancelled'] as const

export const crmTaskTypeSchema = z.enum(CRM_TASK_TYPES)
export const crmTaskPrioritySchema = z.enum(CRM_TASK_PRIORITIES)
export const crmTaskStatusSchema = z.enum(CRM_TASK_STATUSES)

export type CrmTaskType = z.infer<typeof crmTaskTypeSchema>
export type CrmTaskPriority = z.infer<typeof crmTaskPrioritySchema>
export type CrmTaskStatus = z.infer<typeof crmTaskStatusSchema>

export const crmTaskSchema = z.object({
  id: uuidSchema,
  dealId: uuidSchema,
  title: z.string(),
  type: crmTaskTypeSchema,
  priority: crmTaskPrioritySchema,
  notes: z.string().nullable(),
  assigneeId: uuidSchema,
  assigneeName: z.string(),
  creatorId: uuidSchema,
  creatorName: z.string(),
  dueAt: timestampSchema.nullable(),
  reminderAt: timestampSchema.nullable(),
  status: crmTaskStatusSchema,
  completedAt: timestampSchema.nullable(),
  cancelledAt: timestampSchema.nullable(),
  createdAt: timestampSchema,
  updatedAt: timestampSchema,
})

export type CrmTask = z.infer<typeof crmTaskSchema>

const taskFields = {
  title: z.string().trim().min(1, 'Вкажіть назву завдання').max(500),
  type: crmTaskTypeSchema.default('task'),
  priority: crmTaskPrioritySchema.default('normal'),
  notes: z
    .string()
    .trim()
    .max(5000)
    .nullable()
    .transform((value) => value || null),
  assigneeId: uuidSchema,
  dueAt: timestampSchema.nullable(),
  reminderAt: timestampSchema.nullable(),
}

export const createCrmTaskInputSchema = z.object(taskFields)
export type CreateCrmTaskInput = z.infer<typeof createCrmTaskInputSchema>

export const updateCrmTaskInputSchema = z.object(taskFields)
export type UpdateCrmTaskInput = z.infer<typeof updateCrmTaskInputSchema>
